/** Переключатель страниц списка. Один на список групп и на справочник переводов. */
export default function Pager({
	page,
	pageCount,
	onGo,
}: {
	page: number
	pageCount: number
	onGo: (page: number) => void
}) {
	if (pageCount <= 1) return null

	return (
		<div className="pager">
			<span>
				Страница {page + 1} из {pageCount}
			</span>
			<div className="pager__buttons">
				<button className="btn" disabled={page === 0} onClick={() => onGo(0)}>
					«
				</button>
				<button
					className="btn"
					disabled={page === 0}
					onClick={() => onGo(page - 1)}
				>
					Назад
				</button>
				<button
					className="btn"
					disabled={page >= pageCount - 1}
					onClick={() => onGo(page + 1)}
				>
					Вперёд
				</button>
				<button
					className="btn"
					disabled={page >= pageCount - 1}
					onClick={() => onGo(pageCount - 1)}
				>
					»
				</button>
			</div>
		</div>
	)
}
